import { createSearchParams, generatePath, useNavigate } from 'react-router-dom'
import { CLIENT_PAGES_PATH } from '../Constants/ClientRoutes'

export function useNavigateWrapper() {
  const navigate = useNavigate()

  const navigateToHomepage = () => navigate(CLIENT_PAGES_PATH.Homepage)

  const navigateToOmnichannel = () => navigate(CLIENT_PAGES_PATH.Omnichannel)

  const navigateToRule = (id: number) => navigate(generatePath(CLIENT_PAGES_PATH.Rule, { id: id }))

  const navigateToSubrule = (id: number, queryParams: string = '') =>
    navigate(addQueryParam(generatePath(CLIENT_PAGES_PATH.Subrule, { id: id }), queryParams))

  const navigateToSettings = () => navigate(CLIENT_PAGES_PATH.Settings)

  const navigateToChannels = () => navigate(CLIENT_PAGES_PATH.ChannelSettings)

  const navigateToExpenses = () => navigate(CLIENT_PAGES_PATH.Expenses)

  return {
    navigate,
    navigateToHomepage,
    navigateToOmnichannel,
    navigateToRule,
    navigateToSubrule,
    navigateToSettings,
    navigateToChannels,
    navigateToExpenses,
  }
}

const addQueryParam = (url: string, queryParams: string): string => {
  return url + (queryParams ? '?' + queryParams : queryParams)
}

export type NavigationWrapper = ReturnType<typeof useNavigateWrapper>
export const generateQueryParams = (params: { [key: string]: string }): string => {
  return createSearchParams(params).toString()
}
